import { useSelector } from "react-redux";

import { TAppState } from "store/root.store";

export const useAuthSelector = () => useSelector((state: TAppState) => state.authReducer);

export const getIsAuth = (state: TAppState) => state.authReducer.isAuth;
